import { createFileRoute } from "@tanstack/react-router";
import { OAuthCallbackPage } from "@/features/integrations";

export const Route = createFileRoute("/_authenticated/account/integrations/callback")({
  component: OAuthCallbackPage,
});
